<form
  #addUserForm="ngForm"
  (keydown.enter)="$event.preventDefault()">
  <h1 mat-dialog-title>{{ ("addUser" | i18n) || "Add user" | titlecase }}</h1>
  <div mat-dialog-content>
    <ng-container *ngIf="!data.customer?.enableJobRequestProcess">
      <mat-slide-toggle
        [ngModel]="toggleValue$ | async"
        (ngModelChange)="toggleUserRole()"
        name="isCreatingDispo"
        data-cy="create-dispo-slide-toggle"
        *ngIf="
          (permissionsService.canCreateDispoUsers$ | async) &&
          (permissionsService.canCreatePoolerUsers$ | async)
        ">
        {{ ("roleEnum." + roleEnum.DISPO | i18n) || "Pooler" | titlecase }}
      </mat-slide-toggle>
    </ng-container>
    <ng-container
      *ngIf="
        data.customer?.enableJobRequestProcess && (canCreateUsers$ | async)
      ">
      <mat-form-field>
        <mat-label>{{ ("userRole" | i18n) || "Rolle" | titlecase }}</mat-label>
        <mat-select
          [ngModel]="newUserRole$ | async"
          (ngModelChange)="newUserRole$.next($event)"
          required
          name="userRole"
          data-cy="user-role-select"
          [disabled]="!(canCreateMultipleRoles$ | async)">
          <mat-option
            *ngIf="permissionsService.canCreatePoolerUsers$ | async"
            [value]="roleEnum.POOL">
            {{ ("roleEnum." + roleEnum.POOL | i18n) || "Pooler" | titlecase }}
          </mat-option>
          <mat-option
            *ngIf="permissionsService.canCreateRequesterUsers$ | async"
            [value]="roleEnum.REQUESTER">
            {{
              ("roleEnum." + roleEnum.REQUESTER | i18n) || "Besteller"
                | titlecase
            }}
          </mat-option>
          <mat-option
            *ngIf="permissionsService.canCreateDispoUsers$ | async"
            [value]="roleEnum.DISPO">
            {{
              ("roleEnum." + roleEnum.DISPO | i18n) || "Disponent" | titlecase
            }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <mat-form-field>
      <input
        matInput
        type="email"
        name="emailInput"
        required
        [placeholder]="('email' | i18n) || 'Email'"
        #emailInput="ngModel"
        [ngModel]="email$ | async"
        (ngModelChange)="email$.next($event)"
        data-cy="create-user-email-input"
        pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}" />
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      (click)="onNoClick()">
      {{ ("cancel" | i18n) || "cancel" | uppercase }}
    </button>
    <button
      mat-button
      [disabled]="!addUserForm.valid"
      [mat-dialog-close]="{
        email: transformedEmail$ | async,
        newUserRole: newUserRole$ | async
      }"
      data-cy="create-user-submit-button">
      {{ ("add" | i18n) || "add" | uppercase }}
    </button>
  </div>
</form>
